import { render } from "./AdminVersionsPage.vue?vue&type=template&id=9798e3ec&scoped=true"
import script from "./AdminVersionsPage.vue?vue&type=script&lang=js"
export * from "./AdminVersionsPage.vue?vue&type=script&lang=js"

import "./AdminVersionsPage.vue?vue&type=style&index=0&id=9798e3ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9798e3ec"]])

export default __exports__